var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.buildings.length > 0 || _vm.flats.length > 0))?_c('section',{staticClass:"favorite-page"},[_c('favorite-list',{attrs:{"type":'buildings',"items":_vm.buildings}}),_vm._v(" "),_c('favorite-list',{attrs:{"type":'flats',"items":_vm.flats}})],1):_c('section',{staticClass:"favorite-page mb-4"},[_vm._v("\n  В избранном пока ничего нет.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }